import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import logo from './assets/images/logo.jpeg';
import './App.css';

// Import your pages
import Home from './pages/Home';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import ScrollToTopButton from "./components/ScrollToTopButton";
import ScrollToTopOnLoad from "./components/ScrollToTopOnLoad";


function LandingPage() {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    const button = document.querySelector(".explore-btn");
    if (button) {
      button.classList.add("jump");
      setTimeout(() => {
        navigate("/home");
      }, 500);
    }
  };

  return (
    <div className="App landing-page">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p></p>

        {/* ✨ Pulsing round arrow button */}
        <button className="explore-btn" onClick={handleExploreClick}>
          <span className="arrow">&#x2193;</span>
        </button>
      </header>
    </div>
  );
}


function App() {
  return (
    <Router>
     <ScrollToTopOnLoad /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/home"
          element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          }
        />
      </Routes>
        <ScrollToTopButton />  
    </Router>
  );
}

export default App;
